<header class="app-header">
  <img src="/assets/img/new-logo.png" alt="doqfy-logo" class="logo-image">
  
  <div class="logout-wrapper" (click)="back()">
    <span class="logout-text">Back</span>
    <i class="pi pi-arrow-left"></i>
  </div>
</header>

<div class="custom-container px-4">
  <div class="title_header mt-3 mb-4 py-4 header-split">
    <div class="header-left">
      <h3 class="card-title">Generated Signature Links</h3>
    </div>

    <div class="header-right signer-details">
      @if (signerDetails?.name && signerDetails.name !== '---') {
        <div class="detail-item">
          <span class="detail-label">Name:</span>
          <span class="detail-value">{{ signerDetails.name }}</span>
        </div>
      }
      @if (signerDetails?.email && signerDetails.email !== '---') {
        <div class="detail-item">
          <span class="detail-label">Email:</span>
          <span class="detail-value">{{ signerDetails.email }}</span>
        </div>
      }
      @if (signerDetails?.contact && signerDetails.contact !== '---') {
        <div class="detail-item">
          <span class="detail-label">Mobile:</span>
          <span class="detail-value">{{ signerDetails.contact }}</span>
        </div>
      }
    </div>
  </div>

  <div class="mt-1 tableScroll">
    <app-data-table
      [columns]="columns"
      [data]="orders"
      [totalRecords]="totalRecords"
      [rows]="rowsPerPage"
      [paginator]="true"
      [lazy]="true"
      emptyMessage="No Records Found"
      (pageChange)="onPageChange($event)"
      (rowsChange)="onRowsPerPageChange($event)">
      <ng-template appTableCell="doqfy_sign_url" let-row>
        <div class="link-display-box">
          <span class="url-text" [title]="row.doqfy_sign_url">{{ row.doqfy_sign_url }}</span>

          <div class="action-icons">
            <a
              class="viewmore clickable action-btn"
              (click)="copyLink(row.doqfy_sign_url)"
              pTooltip="Copy Link"
              tooltipPosition="top"
            >
              <i class="pi pi-copy" style="font-size: 1.2rem"></i>
            </a>

            <a
              class="viewmore clickable action-btn"
              [href]="row.doqfy_sign_url"
              target="_blank"
              pTooltip="Open in new tab"
              tooltipPosition="top"
            >
              <i class="pi pi-external-link" style="font-size: 1.1rem"></i>
            </a>
          </div>
        </div>
      </ng-template>
    </app-data-table>
  </div>
</div>
